var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon feather-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 173",
    d: "M2.51112 2.44873H13.0889C13.2878 2.44873 13.4847 2.48771 13.6684 2.56343C13.8521 2.63915 14.0189 2.75013 14.1593 2.88999C14.2997 3.02986 14.4109 3.19586 14.4865 3.37848C14.5621 3.5611 14.6007 3.75675 14.6 3.9542V14.4946C14.6007 14.692 14.5621 14.8877 14.4865 15.0703C14.4109 15.2529 14.2997 15.4189 14.1593 15.5588C14.0189 15.6987 13.8521 15.8096 13.6684 15.8854C13.4847 15.9611 13.2878 16.0001 13.0889 16.0001H2.51112C2.31222 16.0001 2.11528 15.9611 1.93159 15.8854C1.7479 15.8096 1.58108 15.6987 1.44069 15.5588C1.3003 15.4189 1.18911 15.2529 1.11348 15.0703C1.03786 14.8877 0.999299 14.692 1.00001 14.4946V3.9542C0.999299 3.75675 1.03786 3.5611 1.11348 3.37848C1.18911 3.19586 1.3003 3.02986 1.44069 2.88999C1.58108 2.75013 1.7479 2.63915 1.93159 2.56343C2.11528 2.48771 2.31222 2.44873 2.51112 2.44873Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 174",
    d: "M10.8222 1V3.89306",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 175",
    d: "M4.77789 1V3.89306",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 176",
    d: "M1 7.00037H14.6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.78452631d5a2fa42a98044798dcc0ed8.svg";
export { ForwardRef as ReactComponent };